require('./expensesByCategoryInfo.scss');

// @vendors
import PropTypes from 'prop-types';
import React from 'react'
import classnames from 'classnames'
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

// @components
import { OKIconCategorization } from 'commonsComponents/OKIconCategorization';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import ExpensesByCategoryFilter from '../expensesByCategoryFilter/expensesByCategoryFilter';
import FilterTags from 'components/commons/filters/filterTags';
import MustRender from '../commons/components/MustRender'

// @constants
import { PFM_FILTERS } from 'constants/index';
import { getCategoryIconURL } from 'utilities/expensesByCategories/categoriesUtilities';

function ExpensesByCategoryInfo ({ selectedCategory, movementsTotalAmount, currency, movementsAmount, hasActivedFilters, onClearFilter, onResetFilters, onFilter, onOpenModal }) {
    const categoryIcon = getCategoryIconURL(selectedCategory.categoryName),
        isAmountPositive = selectedCategory.amount >= 0,
        classes = classnames('col-xs-12', { 'col-md-8': isAmountPositive });

    return (
        <section className="col-xs-12">
            <div className="expenses-by-category-info__content">
                <div className="row expenses-by-category-info__category">
                    <div className="col-xs-12 col-md-8">
                        <span className="expenses-by-category-info__category__icon">
                            <span className="expenses-by-category-info__category__icon-wrapper">
                                <OKIconCategorization activeHover={false} iconUrl={categoryIcon} size="large"/>
                            </span>
                            <div className="expenses-by-category-info__category__name">
                                {formatText(`categorized-${selectedCategory.categoryName}`)}
                            </div>
                        </span>
                    </div>
                    <div className="col-xs-12 col-md-4 expenses-by-category-info__buttons">
                        <MustRender isTrueThat={hasActivedFilters}>
                            <button className="expenses-by-category-info__buttons-clean" onClick={onResetFilters}>
                                <FormattedText value="filters-clean" />
                            </button>
                        </MustRender>
                        <ExpensesByCategoryFilter onFilter={onFilter} onClearFilter={onClearFilter} onOpenModal={onOpenModal}/>
                    </div>
                </div>
                <div className="row expenses-by-category-info__movements-detail">
                    <div className={classes}>
                        <MustRender isTrueThat={hasActivedFilters}>
                            <FilterTags filtersId={PFM_FILTERS} onFilter={onFilter}/>
                        </MustRender>
                    </div>
                    <MustRender isTrueThat={isAmountPositive}>
                        <div className="col-xs-12 col-md-4">
                            <div className="expenses-by-category-info__movements-detail__information">
                                <p className="count-expense"><FormattedText value="categoriesInfo-total"/><span>
                                    <OneLineSymbolAmount
                                        language={getLanguage()}
                                        positiveAmount
                                        amountObject={{amount: movementsTotalAmount, currencySymbol: currency}}
                                        amountObjectFormatted={{currencySymbol: currency}}
                                    />
                                </span></p>
                                <p className="count-movements">{movementsAmount} <FormattedText value="categoriesInfo-movements"/></p>
                            </div>
                        </div>
                    </MustRender>
                </div>
            </div>
        </section>
    );
}

ExpensesByCategoryInfo.defaultProps = {
    movementsAmount: 0,
};

ExpensesByCategoryInfo.propTypes = {
    currency: PropTypes.string,
    hasActivedFilters: PropTypes.bool,
    onFilter: PropTypes.func,
    onClearFilter: PropTypes.func,
    onOpenModal: PropTypes.func,
    onResetFilters: PropTypes.func,
    selectedCategory: PropTypes.object,
    movementsTotalAmount: PropTypes.number,
    movementsAmount: PropTypes.number,
};

module.exports = ExpensesByCategoryInfo;
